"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_TRIAL_DAYS = exports.MIN_TRIAL_DAYS = exports.DEFAULT_TRIAL_DAYS = exports.DEFAULT_TRIAL_ENABLED = exports.DEFAULT_PAYWALL_CONFIG_ENABLED = exports.PAYWALL_CONFIG_DOC_ID = void 0;
/** Document ID for the singleton paywall config */
exports.PAYWALL_CONFIG_DOC_ID = 'paywall-config';
/** Default paywall rollout state when config is missing or malformed */
exports.DEFAULT_PAYWALL_CONFIG_ENABLED = false;
/**
 * Whether the no-card trial mode is active. When true (and `enabled` is also
 * true), a user is auto-granted an N-day trial after their first scan instead of
 * seeing the card-up-front paywall. Default false = card-up-front (current prod)
 * — so a missing field can never accidentally start handing out free trials.
 */
exports.DEFAULT_TRIAL_ENABLED = false;
/**
 * No-card trial length (days) when `trialDays` is unset or out of range.
 * Keep in sync with the historical hard-coded value so existing behaviour is
 * preserved when the config doc omits the field.
 */
exports.DEFAULT_TRIAL_DAYS = 30;
/** Inclusive bounds the configured `trialDays` is clamped to (guardrail against a fat-finger). */
exports.MIN_TRIAL_DAYS = 1;
exports.MAX_TRIAL_DAYS = 120;
//# sourceMappingURL=PaywallConfig.js.map